import { render, staticRenderFns } from "./DashboardBanner.vue?vue&type=template&id=7740d724&scoped=true&"
import script from "./DashboardBanner.vue?vue&type=script&lang=js&"
export * from "./DashboardBanner.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBanner.vue?vue&type=style&index=0&id=7740d724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7740d724",
  null
  
)

export default component.exports